<script>
	import { cn } from '$lib/utils';

	let className = '';
	export let title = 'Example Feature';
	export let description = 'This is a feature';

	export { className as class };
</script>

<div
	class={cn(
		'h-54 border-darkTertiary bg-darkSecondary hover:border-darkQuaternary flex flex-col gap-10 rounded-lg border p-5 shadow-md transition-colors',
		className
	)}
>
	<div class="flex flex-row items-center justify-start gap-2">
		<slot name="icon" />
	</div>
	<div class="flex flex-col gap-2">
		<h3 class="text-lg">
			{title}
		</h3>
		<p class="text-lightTertiary text-sm font-light">
			{description}
		</p>
	</div>
</div>
